/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Rv_Cons_1Inputs */

const en_pc_rv_cons_1 = /** @type {(inputs: Pc_Rv_Cons_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Early alpha, so bugs and missing features`)
};

const zh_pc_rv_cons_1 = /** @type {(inputs: Pc_Rv_Cons_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`早期 Alpha，会有 bug 和功能缺失`)
};

/**
* | output |
* | --- |
* | "Early alpha, so bugs and missing features" |
*
* @param {Pc_Rv_Cons_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_rv_cons_1 = /** @type {((inputs?: Pc_Rv_Cons_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Rv_Cons_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_rv_cons_1(inputs)
	return zh_pc_rv_cons_1(inputs)
});
export { pc_rv_cons_1 as "pc.rv.cons.1" }